import { isNaNymqb93xtq8w8 as isNaN_0 } from '../../../NumbersJs.mjs';
//region block: imports
var trunc = Math.trunc;
//endregion
//region block: pre-declaration
//endregion
function negate(_this__u8e3s4) {
  var tmp = BigInt;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.internal.unaryMinus' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$4 = -_this__u8e3s4;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return tmp.asIntN(64, tmp$ret$4);
}
function add(_this__u8e3s4, other) {
  // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
  var tmp = BigInt;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.internal.plus' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$7 = _this__u8e3s4 + other;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return tmp.asIntN(64, tmp$ret$7);
}
function subtract(_this__u8e3s4, other) {
  // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
  var tmp = BigInt;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.internal.minus' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$7 = _this__u8e3s4 - other;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return tmp.asIntN(64, tmp$ret$7);
}
function multiply(_this__u8e3s4, other) {
  // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
  var tmp = BigInt;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.internal.times' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$7 = _this__u8e3s4 * other;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return tmp.asIntN(64, tmp$ret$7);
}
function divide(_this__u8e3s4, other) {
  // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
  var tmp = BigInt;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.internal.div' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$7 = _this__u8e3s4 / other;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return tmp.asIntN(64, tmp$ret$7);
}
function modulo(_this__u8e3s4, other) {
  // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
  var tmp = BigInt;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.internal.rem' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$7 = _this__u8e3s4 % other;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return tmp.asIntN(64, tmp$ret$7);
}
function shiftLeft(_this__u8e3s4, numBits) {
  // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
  var tmp = BigInt;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.internal.shl' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$7 = _this__u8e3s4 << fromInt(sanitizeBitShiftRHS(numBits));
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return tmp.asIntN(64, tmp$ret$7);
}
function sanitizeBitShiftRHS(numBits) {
  return numBits & 63;
}
function shiftRight(_this__u8e3s4, numBits) {
  // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
  var tmp = BigInt;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.internal.shr' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$7 = _this__u8e3s4 >> fromInt(sanitizeBitShiftRHS(numBits));
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return tmp.asIntN(64, tmp$ret$7);
}
function shiftRightUnsigned(_this__u8e3s4, numBits) {
  // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
  var tmp = BigInt;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var rhs = fromInt(sanitizeBitShiftRHS(numBits));
  // Inline function 'kotlin.js.internal.shr' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$7 = BigInt.asUintN(64, _this__u8e3s4) >> rhs;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return tmp.asIntN(64, tmp$ret$7);
}
function numberToLong(value) {
  var tmp0_elvis_lhs = (!(value == null) ? typeof value === 'bigint' : false) ? value : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.js.unsafeCast' call
    tmp = fromNumber(value);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function fromNumber(value) {
  var tmp;
  if (isNaN_0(value)) {
    tmp = 0n;
  } else if (value <= -9.223372036854776E18) {
    tmp = -9223372036854775808n;
  } else if (value + 1 >= 9.223372036854776E18) {
    tmp = 9223372036854775807n;
  } else {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = BigInt(trunc(value));
  }
  return tmp;
}
function fromInt(value) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return BigInt(value);
}
function convertToByte(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return truncating(_this__u8e3s4, 8);
}
function truncating(_this__u8e3s4, bitSize) {
  var tmp = BigInt;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.internal.toNumber' call
  var self_0 = tmp.asIntN(bitSize, _this__u8e3s4);
  // Inline function 'kotlin.js.unsafeCast' call
  return Number(self_0);
}
function toNumber(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.internal.toNumber' call
  var self_0 = _this__u8e3s4;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return Number(self_0);
}
function convertToShort(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return truncating(_this__u8e3s4, 16);
}
function convertToInt(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return truncating(_this__u8e3s4, 32);
}
function longFromTwoInts(low, high) {
  return shiftLeft(fromInt(high), 32) | fromInt(low) & 4294967295n;
}
function lowBits(_this__u8e3s4) {
  return convertToInt(_this__u8e3s4);
}
function highBits(_this__u8e3s4) {
  return convertToInt(shiftRight(_this__u8e3s4, 32));
}
function toStringImpl(_this__u8e3s4, radix) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.toString(radix);
}
//region block: exports
export {
  add as add2suhfggl4zvkk,
  convertToByte as convertToByte2t4hntblnhq2k,
  convertToInt as convertToInty04h231mmjoh,
  convertToShort as convertToShortn6n5n7ruahkm,
  divide as dividelr0uqtdj497z,
  fromInt as fromInt2ii0rejb1w62w,
  highBits as highBitstfrzt3uu2jig,
  longFromTwoInts as longFromTwoInts3rf7tdb7ckz62,
  lowBits as lowBits2hhv195ivumfc,
  modulo as modulooi4g1kq3dmtt,
  multiply as multiply2k9eolhnz1bjv,
  negate as negate13xrbakfwasjy,
  numberToLong as numberToLong2pakxeg38estk,
  shiftLeft as shiftLeft3tsh2sstjchzn,
  shiftRightUnsigned as shiftRightUnsigned1ga7wnvbv2qur,
  shiftRight as shiftRight2gqph14wydb8s,
  subtract as subtract2orl8z9upxd9l,
  toNumber as toNumber2e2hj9zugjwi2,
  toStringImpl as toStringImpl3nvg2sadx4cfk,
};
//endregion

//# sourceMappingURL=longAsBigInt.mjs.map
